module.exports = __webpack_public_path__ + "static/media/PM97.c7ce3753.png";